module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/pathways-deco-right-b60504c8c41380f8c3b86673e4a3edf1.svg";